import { Route, Routes } from "react-router-dom";
import { PortalShell, RequireCapability } from "./components/PortalShell";
import { LoginPage } from "./pages/LoginPage";
import { TenantSelectPage } from "./pages/TenantSelectPage";
import { DashboardPage } from "./pages/DashboardPage";
import { ProfilePage } from "./pages/ProfilePage";
import { AdminUsersPage } from "./pages/AdminUsersPage";
import { StructurePage } from "./pages/StructurePage";
import { PeoplePage } from "./pages/PeoplePage";
import { OccupanciesPage } from "./pages/OccupanciesPage";
import { InvitationsPage } from "./pages/InvitationsPage";
import { DevicesPage } from "./pages/DevicesPage";
import { ImportPage } from "./pages/ImportPage";
import { AuditPage } from "./pages/AuditPage";
import { ActivationPage } from "./pages/ActivationPage";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/ativar" element={<ActivationPage />} />
      <Route path="/selecionar-condominio" element={<TenantSelectPage />} />
      <Route element={<PortalShell />}>
        <Route index element={<DashboardPage />} />
        <Route
          path="perfil"
          element={
            <RequireCapability capability="profile.view">
              <ProfilePage />
            </RequireCapability>
          }
        />
        <Route
          path="usuarios"
          element={
            <RequireCapability capability="admins.view">
              <AdminUsersPage />
            </RequireCapability>
          }
        />
        <Route
          path="estrutura"
          element={
            <RequireCapability capability="structure.view">
              <StructurePage />
            </RequireCapability>
          }
        />
        <Route
          path="pessoas"
          element={
            <RequireCapability capability="people.view">
              <PeoplePage />
            </RequireCapability>
          }
        />
        <Route
          path="ocupacoes"
          element={
            <RequireCapability capability="occupancies.view">
              <OccupanciesPage />
            </RequireCapability>
          }
        />
        <Route
          path="convites"
          element={
            <RequireCapability capability="invitations.view">
              <InvitationsPage />
            </RequireCapability>
          }
        />
        <Route
          path="dispositivos"
          element={
            <RequireCapability capability="devices.view">
              <DevicesPage />
            </RequireCapability>
          }
        />
        <Route
          path="importacao"
          element={
            <RequireCapability capability="imports.run">
              <ImportPage />
            </RequireCapability>
          }
        />
        <Route
          path="auditoria"
          element={
            <RequireCapability capability="audit.view">
              <AuditPage />
            </RequireCapability>
          }
        />
        <Route
          path="*"
          element={
            <section className="panel">
              <h2>Página não encontrada</h2>
              <p>O endereço acessado não existe no portal.</p>
            </section>
          }
        />
      </Route>
    </Routes>
  );
}
